import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.current-plan', {
        url: '/currentPlan',
        component: 'currentPlan',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/current-plan/current-plan.state.js